import { FormattedMessage } from "react-intl";

import { formatTime } from "src/utils/breakReason";

import { Box } from "@mui/material";

import {
	BreakReasonName,
	EndBreakPageButton,
	InfoText,
	LimitTimeDisplay,
	PageContainer,
	PageIcon,
	PageTimeDisplay,
	StatusLabel,
	TimeWrapper
} from "./styles";

import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import AccessTimeIcon from '@mui/icons-material/AccessTime';


const BreakReasonTimerPage = ({
	status,
	breakreasonactive,
	elapsedTime,
	breaklimit,
	exceededTime,
	handleOpenEndBreakDialog,
	intl
}) => {

	return (
		<PageContainer status={status}>
			<PageIcon status={status}>
				<PauseCircleOutlineIcon />
			</PageIcon>

			<BreakReasonName status={status}>
				{breakreasonactive?.reasonbreak?.name || intl.formatMessage({ id: "break.reason.time.paused" })}
			</BreakReasonName>

			<StatusLabel status={status}>
				{status === 'exceeded'
					? intl.formatMessage({ id: "break.reason.time.exceeded" })
					: intl.formatMessage({ id: "break.reason.time.paused" })}
			</StatusLabel>

			<TimeWrapper>
				<PageTimeDisplay status={status}>
					{formatTime(elapsedTime)}
				</PageTimeDisplay>

				<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '16px' }}>
					<AccessTimeIcon
						sx={{
							marginRight: '6px'
						}}
					/>

					<LimitTimeDisplay status={status}>
						<FormattedMessage id="break.reason.limit" values={{ limit: breaklimit }} />
					</LimitTimeDisplay>
				</Box>
			</TimeWrapper>

			<EndBreakPageButton
				status={status}
				variant="contained"
				startIcon={<PauseCircleOutlineIcon />}
				onClick={handleOpenEndBreakDialog}
			>
				<FormattedMessage id="break.reason.time.end" />
			</EndBreakPageButton>

			{status === 'exceeded' && (
				<InfoText status={status}>
					<FormattedMessage id="break.reason.time.exceeded.info" values={{ exceededTime }} />
				</InfoText>
			)}

			{status === 'warning' && (
				<InfoText status={status}>
					<FormattedMessage id="break.reason.time.limit.warning" />
				</InfoText>
			)}
		</PageContainer>
	);
};

export default BreakReasonTimerPage;